import styled from 'styled-components';

export const Container = styled.div`

`;
export const ContainerVideo = styled.div`
    margin-bottom: 10px;
    min-height: 450px;
`;